import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import { Field } from "formik";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { Checkbox, Select as MuiSelect, Chip } from "@material-ui/core";

import useStyles from "assets/jss/material-dashboard-react/components/customSelectStyle";
import ErrorMessage from "@Components/ErrorMessage";
import { useTranslation } from "react-i18next";

const MultiSelect = (props) => {
  const { t } = useTranslation();
  const {
    label,
    required,
    name,
    options,
    errorMessage,
    showChips,
    ...rest
  } = props;
  const classes = useStyles();

  const getSelectedValue = (selected, options) => {
    let selectedValues = "";
    if (options.length) {
      for (let i = 0; i < selected.length; ++i) {
        try {
          selectedValues +=
            options.find((option) => option.id === selected[i]).name + ", ";
        } catch (e) {
          // pass
        }
      }
    }
    return selectedValues;
  };

  return (
    <Field name={name} multiple>
      {(props) => {
        const { field, meta } = props;
        return (
          <>
            <InputLabel
              htmlFor={name}
              className={clsx(classes.label, {
                [classes.error]: errorMessage || (meta.error && meta.touched),
              })}
            >
              {t(label)}
              {required ? <span style={{ color: "red" }}> *</span> : null}
            </InputLabel>
            <FormControl variant="outlined" className={classes.formControl}>
              <MuiSelect
                value={field.value}
                autoWidth
                error={Boolean(meta.touched) && Boolean(meta.error)}
                multiple
                renderValue={(selected) =>
                  selected && selected.length && options.length ? (
                    showChips ? (
                      <div className={classes.chips}>
                        {selected.map((value) => (
                          <Chip
                            key={value}
                            label={value}
                            className={classes.chip}
                          />
                        ))}
                      </div>
                    ) : (
                      getSelectedValue(selected, options)
                    )
                  ) : (
                    t("Select " )+ t(label)
                  )
                }
                displayEmpty
                {...field}
                {...rest}
              >
                <MenuItem disabled value="">
                  {t("Select ") + t(label)}
                </MenuItem>
                {options.map((option, index) => {
                  return (
                    <MenuItem key={index} value={option.id}>
                      <Checkbox
                        size="small"
                        color="primary"
                        checked={
                          option && option.id
                            ? field.value.indexOf(option.id) > -1
                            : []
                        }
                      />
                      {t(option.name)}
                    </MenuItem>
                  );
                })}
              </MuiSelect>
            </FormControl>
            <ErrorMessage message={errorMessage ? errorMessage : meta.error} />
          </>
        );
      }}
    </Field>
  );
};

MultiSelect.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
  showChips: PropTypes.bool,
  options: PropTypes.array,
  field: PropTypes.object,
  meta: PropTypes.object,
  errorMessage: PropTypes.array,
};

export default MultiSelect;
